import axios from 'axios';

import { Project, projectConfigs } from '../config/projects';
import { useGlobalStore } from '../stores/global.store';

function createProjectClient(project: Project) {
  const client = axios.create({
    baseURL: projectConfigs[project].apiUrl,
  });

  client.interceptors.request.use((config) => {
    const state = useGlobalStore.getState();
    const token = state.sessions[project].token;

    config.headers.Accept = 'application/json';
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    if (project === 'hatfa') {
      config.headers['X-Lang'] = state.localization.currentLanguage;
    }
    return config;
  });

  client.interceptors.response.use(
    (response) => response,
    (error) => {
      if (axios.isAxiosError(error) && error.response?.status === 401) {
        useGlobalStore.getState().logout(project);
      }
      return Promise.reject(error);
    },
  );

  return client;
}

export const projectAxios = {
  hatfa: createProjectClient('hatfa'),
  kitaba: createProjectClient('kitaba'),
};

export const axiosInstance = projectAxios.hatfa;
